import React, { useContext, useEffect, useState } from "react";
import "../../pages/TICCAProduct/TiccaProduct.scss";
import "./AIExecutiveSummary.scss";
import { Context } from "../../contextApi/contextProvider";
import { useNavigate } from "react-router-dom";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import { MarkDocumentRead } from "../../utils/Api/api";
import parser from "html-react-parser";
import { Button } from "@mui/material";
import { Server, Cpu, Shield, Settings, Code, DollarSign, ArrowLeft, ArrowRight } from "lucide-react";
import "../home/Home.scss";
import "../QA/qa.scss";
import {
  ShimmerLoaderwhite,
  ShimmerLoader,
  ShimmerLoaderwhiteOneLine,
  ShimmerOfprofileLoader,
} from "../../utils/loader/ShimmerLoader";
import { PageRoutes } from "../../utils/pageRoutes";
import styles from "./InfrastructureExecutionPlan.module.css";
import { useScroll, useTransform, motion } from "framer-motion";
import { StandardHeroLayout } from "./StandardHeroLayout";

const AIExecutiveSummary = () => {
  const navigator = useNavigate();
  const token = JSON.parse(localStorage.getItem("access_token") as string);
  const { scrollYProgress } = useScroll();

  const contentParallax = useTransform(scrollYProgress, [0.1, 0.8], [50, -50]);
  const { userLoginData, accessDoc } = useContext(Context);

  const loaction = useGeoLocation();
  const [htmlString, setHtmlStr] = useState([]);

  const fetchCmsContent = async () => {
    const response = await cmsPrivateContent({
      post_id: "13029",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  const codeExample = `POST /api/v1/workflow/summarize
{ "input": "long_text", "output_format": "abstract", "max_tokens": 500 }`;
  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["13029"] !== "de") {
      if (accessDoc["13029"] == "ALLOWED") {
        readDoc();
        fetchCmsContent();
      } else {
        navigator("/");
      }
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }

    document.title = "TICCA | AI Executive Summary";
    window.scrollTo(0, 0);
  }, [userLoginData.status, accessDoc]);
  const stripHTMLTags = (htmlString: string): string => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || "";
  };
  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "13029",
      });
    } catch (error) {}
  };
  const phases = [
    {
      id: "phase1",
      title: `${htmlString[7] && htmlString[8]}`,
      objective: `${htmlString[7] && htmlString[9]}`,
      icon: Settings,
      deliverables: [
        `${htmlString[8] && htmlString[10]}`,
        `${htmlString[11] && htmlString[11]}`,
        `${htmlString[12] && htmlString[12]}`,
        `${htmlString[13] && htmlString[13]}`,
        `${htmlString[14] && htmlString[14]}`,
      ],
    },
    {
      id: "phase2",
      title: `${htmlString[15] && htmlString[15]}`,
      objective: `${htmlString[16] && htmlString[16]}`,
      icon: Cpu,
      deliverables: [
        `${htmlString[17] && htmlString[17]}`,
        `${htmlString[18] && htmlString[18]}`,
        `${htmlString[19] && htmlString[19]}`,
        `${htmlString[20] && htmlString[20]}`,
        `${htmlString[21] && htmlString[21]}`,
      ],
    },
    {
      id: "phase3",
      title: `${htmlString[22] && htmlString[22]}`,
      objective: `${htmlString[23] && htmlString[23]}`,
      icon: Code,
      deliverables: [
        `${htmlString[24] && htmlString[24]}`,
        `${htmlString[25] && htmlString[25]}`,
        `${htmlString[26] && htmlString[26]}`,
        `${htmlString[27] && htmlString[27]}`,
        `${htmlString[28] && htmlString[28]}`,
      ],
    },
    {
      id: "phase4",
      title: `${htmlString[29] && htmlString[29]}`,
      objective: `${htmlString[30] && htmlString[30]}`,
      icon: Server,
      deliverables: [
        `${htmlString[31] && htmlString[31]}`,
        `${htmlString[32] && htmlString[32]}`,
        `${htmlString[33] && htmlString[33]}`,
        `${htmlString[34] && htmlString[34]}`,
        `${htmlString[35] && htmlString[35]}`,
      ],
    },
    {
      id: "phase5",
      title: `${htmlString[36] && htmlString[36]}`,
      objective: `${htmlString[37] && htmlString[37]}`,
      icon: DollarSign,
      deliverables: [
        `${htmlString[38] && htmlString[38]}`,
        `${htmlString[39] && htmlString[39]}`,
        `${htmlString[40] && htmlString[40]}`,
        `${htmlString[41] && htmlString[41]}`,
      ],
      financialTargets: [
        `${htmlString[42] && htmlString[42]}`,
        `${htmlString[43] && htmlString[43]}`,
        `${htmlString[44] && htmlString[44]}`,
      ],
    },
    {
      id: "phase6",
      title: `${htmlString[45] && htmlString[45]}`,
      objective: `${htmlString[46] && htmlString[46]}`,
      icon: Shield,
      deliverables: [
        `${htmlString[47] && htmlString[47]}`,
        `${htmlString[47] && htmlString[48]}`,
        `${htmlString[49] && htmlString[49]}`,
      ],
    },
  ];

  return (
    <>
      <div className="home-container ">
        <div
          style={{ height: "auto" }}
          className="home-bg-container ai-bg-container "
        >
          <StandardHeroLayout
            title={`${htmlString[0] && htmlString[0]}`}
            icon={Server}
            currentPage="infrastructure-execution-plan"
          />
        </div>
      </div>
      <section className="executive-summary-section">
        <div className="summary-container">
          {htmlString[1] ? (
            parser(htmlString[1])
          ) : (
            <ShimmerLoaderwhiteOneLine />
          )}
          {htmlString[2] ? parser(htmlString[2]) : <ShimmerLoader />}
        </div>
      </section>
      <section className="ai-solutions-section-wrapper">
        {htmlString[3] ? (
          <div className="ai-solutions-grid-container">
            {" "}
            {parser(htmlString[3])}{" "}
          </div>
        ) : (
          <div className="ai-solutions-grid-container">
            {Array.from({ length: 11 }).map((_, idx) => (
              <div className="ai-solutions-card-wrapper" key={idx}>
                <div className="ai-solutions-card-header">
                  <ShimmerLoaderwhiteOneLine />
                </div>
                <div className="ai-solutions-problem-box">
                  <ShimmerLoaderwhite />
                </div>
                <div className="ai-solutions-solution-box">
                  <ShimmerLoaderwhiteOneLine />
                  <ul className="ai-solutions-solution-list">
                    <ShimmerLoaderwhite />
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <div className={styles.container}>
        {/* Standardized Hero Section */}
        <StandardHeroLayout
          title={`${htmlString[5] && htmlString[5]}`}
          subtitle={`${htmlString[5] && htmlString[6]}`}
          description={`${htmlString[5] && htmlString[7]}`}
          icon={Server}
          currentPage="infrastructure-execution-plan"
          dp={true}
        />

        {/* Content Section */}
        <motion.section
          className={styles.contentSection}
          style={{ y: contentParallax }}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <div className={styles.content}>
            {/* Phases */}
            {phases.map((phase, index) => {
              const IconComponent = phase.icon;
              return (
                <motion.div
                  key={phase.id}
                  className={styles.phaseSection}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.1 * index }}
                  viewport={{ once: true, margin: "-100px" }}
                >
                  <div className={styles.phaseHeader}>
                    <div className={styles.phaseIcon}>
                      <IconComponent className={styles.phaseIconSvg} />
                    </div>
                    <div className={styles.phaseInfo}>
                      <h2 className={styles.phaseTitle}>
                        {phase.title == "undefined" ? (
                          <ShimmerLoaderwhiteOneLine margins />
                        ) : (
                          stripHTMLTags(phase.title as string)
                        )}
                      </h2>
                      <p className={styles.phaseObjective}>
                        {phase.objective != "undefined" && (
                          <strong>Objective:</strong>
                        )}{" "}
                        {phase.objective == "undefined" ? (
                          <ShimmerLoaderwhiteOneLine margins />
                        ) : (
                          stripHTMLTags(phase.objective as string)
                        )}
                      </p>
                    </div>
                  </div>

                  <div className={styles.deliverablesSection}>
                    <h3 className={styles.deliverablesTitle}>Deliverables:</h3>
                    <ul className={styles.deliverablesList}>
                      {phase.deliverables.map((deliverable, i) => (
                        <>
                          {deliverable == "undefined" ? (
                            <ShimmerLoaderwhiteOneLine margins />
                          ) : (
                            <motion.li
                              key={i}
                              className={styles.deliverableItem}
                              initial={{ opacity: 0, x: -20 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              transition={{ duration: 0.6, delay: 0.05 * i }}
                              viewport={{ once: true }}
                            >
                              {stripHTMLTags(deliverable as string)}
                            </motion.li>
                          )}
                        </>
                      ))}
                    </ul>
                  </div>

                  {phase.financialTargets && (
                    <div className={styles.financialSection}>
                      <h3 className={styles.financialTitle}>
                        Financial Targets (per 1,000 GPUs):
                      </h3>
                      <ul className={styles.financialList}>
                        {phase.financialTargets.map((target, i) => (
                          <>
                            {target == "undefined" ? (
                              <ShimmerLoaderwhiteOneLine margins />
                            ) : (
                              <motion.li
                                key={i}
                                className={styles.financialItem}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.05 * i }}
                                viewport={{ once: true }}
                              >
                                {stripHTMLTags(target as string)}
                              </motion.li>
                            )}
                          </>
                        ))}
                      </ul>
                    </div>
                  )}

                  {phase.id === "phase4" && (
                    <div className={styles.codeExample}>
                      <h4 className={styles.codeTitle}>Example endpoint:</h4>
                      <pre className={styles.codeBlock}>
                        <code>{codeExample}</code>
                      </pre>
                    </div>
                  )}
                </motion.div>
              );
            })}

            {/* Investor Takeaway */}
            <motion.div
              id="financial-summary"
              className={styles.takeawaySection}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <h2 className={styles.takeawayTitle}>{ htmlString[50] ? stripHTMLTags(htmlString[50]) : <ShimmerLoaderwhiteOneLine />}</h2>
              <div className={styles.takeawayContent}>
                <p className={styles.takeawayText}>
                  { htmlString[51] ? stripHTMLTags(htmlString[51]) : <ShimmerLoaderwhiteOneLine />}
                </p>
                <ol className={styles.takeawayList}>
                  <li>{ htmlString[52] ? stripHTMLTags(htmlString[52]) : <ShimmerLoaderwhiteOneLine margins />}</li>
                  <li>{ htmlString[53] ? stripHTMLTags(htmlString[53]) : <ShimmerLoaderwhiteOneLine margins />}</li>
                  <li>{ htmlString[54] ? stripHTMLTags(htmlString[54]) : <ShimmerLoaderwhiteOneLine margins />}</li>
                  <li>
                  { htmlString[55] ? stripHTMLTags(htmlString[55]) : <ShimmerLoaderwhiteOneLine margins />}
                  </li>
                  <li>
                   { htmlString[56] ? stripHTMLTags(htmlString[56]) : <ShimmerLoaderwhiteOneLine margins />}
                  </li>
                </ol>
                <p className={styles.takeawayFooter}>
                 { htmlString[57] ? stripHTMLTags(htmlString[57]) : <ShimmerLoaderwhiteOneLine  />}
                </p>
              </div>
            </motion.div>
          </div>
        </motion.section>
      </div>

      <div
        style={{ maxWidth: "1200px" }}
        className="Seamlessly-integrate-TICCA  AI-executive-summary-section-wrapper"
      >
        {htmlString[4] ? (
          <>{parser(htmlString[4])}</>
        ) : (
          <ShimmerLoaderwhiteOneLine />
        )}

         <div className="w-full flex justify-center py-10">
        <div className="w-full max-w-[520px] px-2 flex flex-row items-center gap-3">
          {/* Back Button */}
          <div className="relative group w-1/2">
            <button
              onClick={() => {
                navigator(PageRoutes.Intro);
              }}
              className="
              w-full flex items-center justify-center gap-2 px-4 py-3 rounded-2xl
              bg-white text-gray-700 font-semibold shadow-md
              border border-gray-200
              hover:shadow-lg hover:bg-gray-50
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
            >
              <>
                <ArrowLeft size={18} />
                Back
              </>
            </button>

            {/* Tooltip */}
            <div
              className="
              hidden md:block absolute left-1/2 -translate-x-1/2 bottom-full mb-[-5px] z-50 pointer-events-none
              bg-slate-800 text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
            >
              Intro
            </div>
          </div>

          {/* Next Button */}
          <div className="relative group w-1/2">
            <button
              onClick={() => {
                navigator(PageRoutes.question);
              }}
              className="
              w-full flex items-center justify-center gap-2 px-4 py-3 rounded-2xl
              bg-gradient-to-r from-blue-600 to-cyan-400
              text-white font-semibold shadow-md
              hover:shadow-xl hover:scale-[1.02]
              disabled:opacity-60 disabled:cursor-not-allowed
              transition-all duration-300
            "
            >
              <>Talk to our CEO  <ArrowRight size={18} /></>
            </button>

            {/* Tooltip */}
            <div
              className="
              hidden md:block absolute left-1/2 -translate-x-1/2 bottom-full mb-[-5px] z-50 pointer-events-none
              bg-slate-800 text-white text-xs px-3 py-1 rounded-md
              opacity-0 group-hover:opacity-100
              transition-all duration-300
              shadow-md whitespace-nowrap
            "
            >
              Talk to our CEO
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};
export default AIExecutiveSummary;
